import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import type { Movie } from "../../types/movie";
import { fetchMovies } from "../../services/movieService";
import MovieModal from "../MovieModal/MovieModal";
import Loader from "../Loader/Loader";
import ErrorMessage from "../ErrorMessage/ErrorMessage";
import SearchBar from "../SearchBar/SearchBar";
import MovieGrid from "../MovieGrid/MovieGrid";
import ReactPaginate from "react-paginate";
import css from "./App.module.css";

export default function App() {
  const [selectedMovie, setSelectedMovie] = useState<Movie | null>(null);

  const [searchMovies, setSearchMovies] = useState("");

  const [currentPage, setCurrentPage] = useState(1);

  const openModal = (movie: Movie) => {
    setSelectedMovie(movie);
  };
  const closeModal = () => {
    setSelectedMovie(null);
  };

  const {
    data: movies,
    isLoading,
    isError,
    isSuccess,
  } = useQuery({
    queryKey: ["movies", searchMovies, currentPage],
    queryFn: () => {
      return fetchMovies(searchMovies, currentPage);
    },
    enabled: searchMovies.length > 0,
    placeholderData: keepPreviousData,
  });

  const totalPages = movies?.total_pages ?? 0;

  const handleSearch = async (movie: string) => {
    setSearchMovies(movie);
  };
  useEffect(() => {
    if (isSuccess && movies?.results.length === 0) {
      toast.error("No movies found for your request");
    }
  }, [isSuccess, movies]);
  return (
    <div>
      <Toaster />
      <SearchBar onSubmit={handleSearch} />
      {isSuccess && totalPages > 1 && (
        <ReactPaginate
          pageCount={totalPages}
          pageRangeDisplayed={5}
          marginPagesDisplayed={1}
          onPageChange={({ selected }) => setCurrentPage(selected + 1)}
          forcePage={currentPage - 1}
          containerClassName={css.pagination}
          activeClassName={css.active}
          nextLabel="→"
          previousLabel="←"
        />
      )}
      {isError && <ErrorMessage />}
      {isLoading && <Loader />}
      {movies && movies.results.length > 0 && (
        <MovieGrid movies={movies.results} onSelect={openModal} />
      )}
      {selectedMovie && (
        <MovieModal onClose={closeModal} movie={selectedMovie} />
      )}
    </div>
  );
}
